import { createSlice } from '@reduxjs/toolkit';
import { hospitalService } from 'services/hospital';

type CacheState = {
  hospital?: Hospital;
};

const initialState: CacheState = {
  hospital: undefined,
};

export const cacheSlice = createSlice({
  name: 'cache',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(hospitalService.endpoints.hospital.matchFulfilled, (state, { payload }) => {
      state.hospital = payload.data;
    });
  },
});

export const {} = cacheSlice.actions;

export default cacheSlice;
